exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".personalInfoBox___3urLp {\n  height: 100%;\n  background-color: #F7F7F7;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow-y: auto;\n}\n.personalInfoBox___3urLp .title {\n  font-size: 15px;\n  line-height: 23px;\n  color: #9BA0AA;\n  margin: 0;\n  padding: 16px;\n}\n.personalInfoBox___3urLp .list {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 20px 16px;\n  border-bottom: 1px solid #E8E9EB;\n  background: #fff;\n}\n.personalInfoBox___3urLp .list .content-title {\n  color: #20304B;\n  font-size: 15px;\n}\n.personalInfoBox___3urLp .list .content-des {\n  margin-top: 10px;\n  color: #B9BEC3;\n  line-height: 20px;\n}\n.personalInfoBox___3urLp .list .arrow {\n  -ms-flex: 0 0 40px;\n      flex: 0 0 40px;\n  text-align: center;\n  color: #B9BEC3;\n}\n", ""]);

// exports
exports.locals = {
	"personalInfoBox": "personalInfoBox___3urLp"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/routes/personalInfo/index.less
// module id = 1143
// module chunks = 0